import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Input = styled.input`
  width: 80%;
  border: none;
  background-color: ${theme.colors.light};
  padding: 2vh 1vw;
  color: ${theme.colors.dark};
  text-align: center;

  font-size: max(1vw, 12px);
  border-radius: 0.25rem;
`;

export const RecuperaButton = styled.button`
  border: none;
  background-color: ${theme.colors.light};
  padding: 2vh 1vw;
  color: ${theme.colors.dark};
  text-align: center;

  font-size: max(1vw, 12px);
  border-radius: 0.25rem;
`;

export const Button = styled.button`
  color: ${theme.colors.dark};
  font-size: max(8px, 1vw);
  background-color: ${theme.colors.darkGrey};
  padding: 0.4vh 1vw;
  border-radius: 0.25rem;
  margin-right: 1vw;
  margin-left: 1vw;
  margin-top:2vh;
`;

export const Span = styled.span`
  font-size: max(6px, 0.8vw);

`;

export const AlertTitle = styled.h1`
  color: ${theme.colors.dark};
  font-size: max(10px, 1.2vw);
`;

export const DivButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
 
`;
